import { Map } from 'immutable';
import Constants from '../../constants';
import { ACTION_FETCHING, ACTION_SUCCESS, ACTION_ERROR } from '../../constants/action-status';

export const COMMENT_CONTAINER_IDS_ATTRIBUTE = 'postingCommentAnswerIds';
export const CREATING_ANSWER_ATTRIBUTE = 'isCreatingAnswer';
export const FETCHING_ATTRIBUTE = 'isFetching';

export const DEFAULT_STATE = Map({
	isFetching: false,
});

export default function questionViewPageReducer(state = DEFAULT_STATE, action) {
	const containerIds = state.get(COMMENT_CONTAINER_IDS_ATTRIBUTE)
		? state.get(COMMENT_CONTAINER_IDS_ATTRIBUTE)
		: [];
	switch (action.type) {
		case `${Constants.FETCH_QUESTION}_${ACTION_FETCHING}`:
			return state.set(FETCHING_ATTRIBUTE, true);
		case `${Constants.FETCH_QUESTION}_${ACTION_ERROR}`:
		case `${Constants.FETCH_QUESTION}_${ACTION_SUCCESS}`:
			return state.set(FETCHING_ATTRIBUTE, false);

		case `${Constants.CREATE_ANSWER}_${ACTION_FETCHING}`:
			return state.set(CREATING_ANSWER_ATTRIBUTE, true);
		case `${Constants.CREATE_ANSWER}_${ACTION_ERROR}`:
		case `${Constants.CREATE_ANSWER}_${ACTION_SUCCESS}`:
			return state.set(CREATING_ANSWER_ATTRIBUTE, false);

		case `${Constants.CREATE_COMMENT}_${ACTION_FETCHING}`:
			return state.set(COMMENT_CONTAINER_IDS_ATTRIBUTE, [...containerIds, action.params.parentId]);
		case `${Constants.CREATE_COMMENT}_${ACTION_SUCCESS}`:
			const index = containerIds.indexOf(action.params.parentId);
			if (index !== -1) {
				containerIds.splice(index, 1);
				return state.set(COMMENT_CONTAINER_IDS_ATTRIBUTE, containerIds);
			}
			return state;
		default:
			return state;
	}
}
